import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericDocSettlementMethodContainerAdjustmentModel } from "../../../../../../models/aggregates/generic_doc";
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({ providedIn: "root" })
export class GenericDocSettlementMethodAdjustmentService extends BaseApiTemplateService<GenericDocSettlementMethodContainerAdjustmentModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/backoffice-ep';
    this.httpClient = http;
  }

  postAdjustmentSkipPosting(dtoObject: GenericDocSettlementMethodContainerAdjustmentModel, visa: ApiVisa): Observable<ApiResponseModel<GenericDocSettlementMethodContainerAdjustmentModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/skip-posting/backoffice-ep';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/skip-posting/backoffice-ep';
    if (endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<GenericDocSettlementMethodContainerAdjustmentModel>>(
      apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  postAdjustmentCustom(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<GenericDocSettlementMethodContainerAdjustmentModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/custom/backoffice-ep';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'gen-doc/settlement-method-adjustments/custom/backoffice-ep';
    if (endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<GenericDocSettlementMethodContainerAdjustmentModel>>(
      apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
